var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12", lg: "12" } },
        [
          _c("Aggregate", {
            attrs: {
              title: "Projects",
              "error-messages": _vm.$utils.getIfExists(_vm.errors, [
                "input",
                "projects",
              ]),
              ItemConstructor: _vm.CaseModel.Project,
              headers: [
                { text: "Name", value: "name" },
                { text: "Active", value: "active" },
              ],
              "search-bar": "",
              "search-text": _vm.searchText,
              "auto-expand-search-result": "",
            },
            on: {
              "update:searchText": function ($event) {
                _vm.searchText = $event
              },
              "update:search-text": function ($event) {
                _vm.searchText = $event
              },
              change: function ($event) {
                return _vm.$emit("change")
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.active",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("v-switch", {
                        attrs: { label: "Active" },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("change")
                          },
                        },
                        model: {
                          value: item.active,
                          callback: function ($$v) {
                            _vm.$set(item, "active", $$v)
                          },
                          expression: "item.active",
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "default",
                  fn: function (ref) {
                    var item = ref.item
                    var errors = ref.errors
                    return [
                      _c(
                        "v-row",
                        { staticClass: "pa-2", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "9" } },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "text-subtitle-1 font-weight-medium",
                                },
                                [_vm._v(" Resources ")]
                              ),
                              _c(
                                "v-card",
                                { attrs: { outlined: "" } },
                                [
                                  _c(
                                    "v-tabs",
                                    {
                                      attrs: {
                                        vertical: "",
                                        shrink: "",
                                        color: "primary",
                                      },
                                      model: {
                                        value: _vm.activeTab,
                                        callback: function ($$v) {
                                          _vm.activeTab = $$v
                                        },
                                        expression: "activeTab",
                                      },
                                    },
                                    [
                                      _vm._l(_vm.resourcesTabs, function (tab) {
                                        return _c(
                                          "v-tooltip",
                                          {
                                            key: "tab-" + tab.title,
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-tab",
                                                        _vm._g({}, on),
                                                        [
                                                          tab.icons
                                                            ? _vm._l(
                                                                tab.icons,
                                                                function (
                                                                  icon
                                                                ) {
                                                                  return _c(
                                                                    "v-icon",
                                                                    {
                                                                      key: icon,
                                                                      attrs: {
                                                                        size: "24",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            icon
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            : _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                    size: "28",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      tab.icon
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(tab.title)),
                                            ]),
                                          ]
                                        )
                                      }),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c("SystemProjectDemand", {
                                            attrs: {
                                              num_years: _vm.num_years,
                                              year_start:
                                                _vm.settings.year_start,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.demands,
                                              callback: function ($$v) {
                                                _vm.$set(item, "demands", $$v)
                                              },
                                              expression: "item.demands",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c("SystemInverter", {
                                            attrs: {
                                              "num-years": _vm.num_years,
                                              "year-start":
                                                _vm.settings.year_start,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.inverters,
                                              callback: function ($$v) {
                                                _vm.$set(item, "inverters", $$v)
                                              },
                                              expression: "item.inverters",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c("SystemProjectGenerator", {
                                            attrs: {
                                              num_years: _vm.num_years,
                                              year_start:
                                                _vm.settings.year_start,
                                              demands: item.demands,
                                              reserves: item.reserves,
                                              generators: item.generators,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.generators,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "generators",
                                                  $$v
                                                )
                                              },
                                              expression: "item.generators",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c("SystemProjectStorage", {
                                            attrs: {
                                              num_years: _vm.num_years,
                                              year_start:
                                                _vm.settings.year_start,
                                              project: item,
                                              demands: item.demands,
                                              reserves: item.reserves,
                                              generators: item.generators,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.storages,
                                              callback: function ($$v) {
                                                _vm.$set(item, "storages", $$v)
                                              },
                                              expression: "item.storages",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c("SystemProjectMarket", {
                                            attrs: {
                                              num_years: _vm.num_years,
                                              year_start:
                                                _vm.settings.year_start,
                                              reserves: item.reserves,
                                              errors: errors,
                                              "project-coordinates":
                                                item.coordinates,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$emit("change")
                                              },
                                            },
                                            model: {
                                              value: item.markets,
                                              callback: function ($$v) {
                                                _vm.$set(item, "markets", $$v)
                                              },
                                              expression: "item.markets",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _c("SystemProjectReserve", {
                                staticClass: "mt-4",
                                attrs: {
                                  project: item,
                                  num_years: _vm.num_years,
                                  errors: errors,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$emit("change")
                                  },
                                },
                                model: {
                                  value: item.reserves,
                                  callback: function ($$v) {
                                    _vm.$set(item, "reserves", $$v)
                                  },
                                  expression: "item.reserves",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "text-subtitle-1 font-weight-medium",
                                },
                                [_vm._v(" Project Info ")]
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "mb-2",
                                      attrs: { flat: "", outlined: "" },
                                    },
                                    [
                                      _c(
                                        "v-responsive",
                                        { attrs: { "aspect-ratio": 1 / 1 } },
                                        [
                                          _c("ProjectDiagram", {
                                            attrs: {
                                              network: _vm.diagramNetwork(item),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-1 mb-2",
                                  attrs: { flat: "", outlined: "" },
                                },
                                [
                                  _c("InputGeo", {
                                    attrs: {
                                      label: "Coordinates",
                                      "hide-label": "",
                                      "column-layout": "",
                                      responsive: "",
                                    },
                                    model: {
                                      value: item.coordinates,
                                      callback: function ($$v) {
                                        _vm.$set(item, "coordinates", $$v)
                                      },
                                      expression: "item.coordinates",
                                    },
                                  }),
                                  _c("InputMultiSelect", {
                                    attrs: {
                                      items: _vm.layers,
                                      label: "Layer",
                                      "label-size": 4,
                                      multiple: false,
                                      dense: "",
                                    },
                                    on: {
                                      "update:items": function ($event) {
                                        _vm.layers = $event
                                      },
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value: item.layer,
                                      callback: function ($$v) {
                                        _vm.$set(item, "layer", $$v)
                                      },
                                      expression: "item.layer",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-1",
                                  attrs: { flat: "", outlined: "" },
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-subtitle-1 font-weight-medium",
                                    },
                                    [_vm._v("Grid Properties")]
                                  ),
                                  _c("InputTextField", {
                                    attrs: {
                                      label: _vm.schema.xR.title,
                                      type: "number",
                                      "error-messages": _vm.$utils.getIfExists(
                                        errors,
                                        ["xR", "messages"]
                                      ),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit("change")
                                      },
                                    },
                                    model: {
                                      value: item.xR,
                                      callback: function ($$v) {
                                        _vm.$set(item, "xR", _vm._n($$v))
                                      },
                                      expression: "item.xR",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
            model: {
              value: _vm.computedProjects,
              callback: function ($$v) {
                _vm.computedProjects = $$v
              },
              expression: "computedProjects",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }